import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent extends AppComponentGenericComponent implements OnInit {
	@ViewChild('editor') editor;

	editorOptions: any = {
		tabLength: 4,
		showInvisibles: true,
		showIndentGuide: true,
		useSoftTabs: false
	}

	dumpData: any = null;
	headers: HttpHeaders;
	headersPDF: HttpHeaders;

	comuneSync: Subscription;
	comune: any = null;

	gruppiSync: Subscription;
	gruppi: any[] = [];

	attiDisponibiliSync: Subscription;
	attiDisponibili: any[] = [];

	attiUtilizzatiSync: Subscription;
	attiUtilizzati: any[] = [];

	praticheSync: Subscription;
	pratiche: any[] = [];

	gruppiSource: any[] = [];
	gruppoCrea: string = 'select';
	gruppoModifica: string = 'select';
	daAggiungere: string = 'select';
	daModificare: string = 'select';
	templateCode: string = '';
	htmlCode: string = '';
	pdfStream: SafeResourceUrl = null;
	attoDaSimulare: string = 'dump';
	viewCode: string = 'atto';
	bollettino: boolean = false;
	sourceGroup: string = 'gruppo';
	editorMode: string = 'jade';

	constructor(protected dataService: DataService, private domSanitizer: DomSanitizer) {
		super(dataService, 'template');
		this.headers = new HttpHeaders()
			.append('Content-Type', 'application/json')
			.append('Accept', 'application/json');

		this.headersPDF = new HttpHeaders()
			.append('Content-Type', 'application/json')
			.append('Accept', 'application/json')
			.append('responseType', 'blob');
	}

	ngOnInit() {
		this.comuneSync = this.dataService.getComuniService().comune$.subscribe(
			comune => {
				this.comune = comune;
				this.resetSelects();
				this.setDumpData();
			});
		this.gruppiSync = this.dataService.templatesGruppi$.subscribe(
			gruppi => {
				this.gruppi = gruppi;
				this.resetSelects();
			});
		this.praticheSync = this.dataService.pratiche$.subscribe(
			pratiche => {
				this.pratiche = pratiche;
				this.resetSelects();
			});
	}

	setDumpData() {
		this.dumpData = {
			comune: {
				cf: this.comune.codice_fiscale,
				p_iva: this.comune.partita_iva,
				nome: this.comune.nome,
				indirizzo: this.comune.indirizzo,
				civico: this.comune.civico_num,
				cap: this.comune.cap,
				provincia: this.comune.provincia,
				rea: this.comune.rea,
				telefono: this.comune.telefono,
				fax: this.comune.fax,
				email: this.comune.email,
				pec: this.comune.pec,
				responsabile_tributo: 'Mario Rossi',
				codice: this.comune.codice
			},
			contribuente: {
				id_ana: '000006',
				cf: '1234567890123456',
				p_iva: '12345678901',
				nome: 'Maria',
				cognome: 'Bianchi',
				indirizzo: 'Indirizzo',
				civico: '13',
				cap: '00000',
				comune: 'Comune',
				provincia: 'PR',
				societa: '0'
			},
			associati: [
				{
					id_ana: '000007',
					cf: '1234567890123456',
					p_iva: '12345678901',
					nome: 'Giuseppe',
					cognome: 'Garibaldi',
					indirizzo: 'Indirizzo',
					civico: '17',
					cap: '00000',
					comune: 'Comune',
					provincia: 'PR',
					societa: '0',
					relazione: ''
				}
			],
			pratica: {
				dettagli: [
					{
						fase: 'FASE',
						tributo: 'TRIBUTO',
						anno: '2015',
						data_notifica: '15/03/2016',
						dovuto: '€ 652,98',
						arrotondamento: '0.00',
						interessi: '€ 32,69',
						interessi_agg: '€ 13,35', // DA AGGIUNGERE
						sanzioni: '€ 94,23',
						sanzioni_agg: '0', // DA AGGIUNGERE
						notifica_spese: '€ 5,50',
						versato: '€ 0,00',
						debito_residuo: '€ 785,40',
						protocollo_data_import: '15/01/2016', // DA AGGIUNGERE
						note: 'note' // DA AGGIUNGERE
					}
				],
				totale_debito_prec: '€ 785,40',
				totale_debito: '€ 785,40',
				totale_debito_residuo: '€ 795,40',
				oneri_entro_30: '€ 8,75',
				oneri_dopo_30: '€ 17,50',
				totale_interessi_agg: '€ 13,35',
				id_pratica: '000001',
				min_anno: '2015',
				max_anno: '2015',
				notifica_spese_agg: '€ 10,00',
				notifica_diritti: '€ 0,00', // DA AGGIUNGERE
				diritti_pf_agg: '€ 0,00',
				spese_giudiziali: '€ 0,00',
				tot_pagato: '€ 0,00',
				totale_entro_30: '€ 817,50',
				totale_dopo_30: '€ 826,25',
				rate: [
					{
						numero_rata: '1',
						importo_rata: '€ 206.57',
						capitale_rata: '€ 206.56',
						interessi_rata: '€ 0.01',
						inizio_rate: '30/06/2017',
						scadenza_rata: '30/06/2017'
					},
					{
						numero_rata: '2',
						importo_rata: '€ 206.57',
						capitale_rata: '€ 206.56',
						interessi_rata: '€ 0.01',
						inizio_rate: '30/06/2017',
						scadenza_rata: '30/07/2017'
					},
					{
						numero_rata: '3',
						importo_rata: '€ 206.57',
						capitale_rata: '€ 206.56',
						interessi_rata: '€ 0.01',
						inizio_rate: '30/06/2017',
						scadenza_rata: '30/08/2017'
					},
					{
						numero_rata: '4',
						importo_rata: '€ 206.57',
						capitale_rata: '€ 206.56',
						interessi_rata: '€ 0.01',
						inizio_rate: '30/06/2017',
						scadenza_rata: '30/09/2017'
					}
				],
				n_rate: 4
			},
			atto: {
				codice: 'atto',
				pdf_name: 'comune_atto_1.pdf',
				quinto_campo: '123456789012345678',
				importo_intero: '817',
				importo_decimale: '50',
				importo_intero_8_cifre: '00000817',
				min_anno: '2009',
				max_anno: '2010',
				motivazione: 'Motivazione',
				protocollo_num: '01',
				protocollo_data: '01/01/2017',
				protocollo_anno: '2017',
				relata: {
					messo_nome: 'Paolo',
					messo_cognome: 'Verdi',
					raccomandata_num: '12345678901',
					cronologico_num: '1',
					cronologico_data: '13/09/2016',
					spedizione_data: '16/09/2016',
					spedizione_ufficio: 'Poste del Comune',
					spedizione_tipo: 'Raccomandata A/G'
				}
			},
			riferimento: {
				codice: 'rif_atto',
				protocollo_num: '02',
				protocollo_data: '01/02/2017',
				protocollo_anno: '2017',
				notifica_data: '01/03/2017'
			},
			daRettificare: {
				debito_principale: '0.00',
				interessi: '0.00',
				oneri_riscossione: '0.00',
				spese_diritti_notifica: '0.00',
				totale: '0.00',
				entrate: [
					{
						nome: '#######',
						anno: '#######',
						dovuto: '0.00',
						arrotondamento: '0.00',
						dovuto_arrotondato: '0.00',
						versato: '0.00',
						sanzioni: '0.00',
						interessi: '0.00',
						spese_notifica: '0.00',
						totale: '0.00'
					},
					{
						nome: '#######',
						anno: '#######',
						dovuto: '0.00',
						arrotondamento: '0.00',
						dovuto_arrotondato: '0.00',
						versato: '0.00',
						sanzioni: '0.00',
						interessi: '0.00',
						spese_notifica: '0.00',
						totale: '0.00'
					},
				],
			},
			rettificati: {
				debito_principale: '0.00',
				interessi: '0.00',
				oneri_entro_30: '0.00',
				oneri_dopo_30: '0.00',
				spese_diritti_notifica: '0.00',
				totale_entro_30: '0.00',
				totale_dopo_30: '0.00',
				entrate: [
					{
						nome: '#######',
						anno: '#######',
						dovuto: '0.00',
						arrotondamento: '0.00',
						dovuto_arrotondato: '0.00',
						versato: '0.00',
						sanzioni: '0.00',
						interessi: '0.00',
						spese_notifica: '0.00',
						totale: '0.00'
					},
					{
						nome: '#######',
						anno: '#######',
						dovuto: '0.00',
						arrotondamento: '0.00',
						dovuto_arrotondato: '0.00',
						versato: '0.00',
						sanzioni: '0.00',
						interessi: '0.00',
						spese_notifica: '0.00',
						totale: '0.00'
					},
				],
			}
		}
	}

	ngAfterViewInit() {
		this.editor.getEditor().setOptions({
			enableBasicAutocompletion: true
		});
	}

	filtraGruppiSource() {
		this.gruppiSource = [];

		for (let gruppo of this.gruppi) {
			if (this.gruppoCrea.length && gruppo.id != this.gruppoCrea) {
				this.gruppiSource.push(gruppo);
			}
		}
	}

	getAttiDisponibili() {
		console.log('getAttiDisponibili',this.gruppoCrea);
		if (this.gruppoCrea == this.sourceGroup) {
			this.sourceGroup = 'gruppo';
		}
		if (this.gruppoCrea != 'select') {
			this.dataService.openLoader('CARICAMENTO TEMPLATES DISPONIBILI','caricamento lista templates in corso...');
			let body: any = {
				comuneId: this.dataService.getComuniService().getComuneId(),
				gruppoId: this.gruppoCrea,
				gruppoSource: this.sourceGroup
			};

			this.dataService.getCommon().getHttpClient().post<any>('/api/templates/get_disponibili', JSON.stringify(body), { headers: this.headers })
				.subscribe(
					response => {
						console.log('atti disponibili', response);
						this.attiDisponibili = response.data;
						this.dataService.closeLoader();
					}
				);
		}
		else {
			this.daAggiungere = 'select';
			this.attiDisponibili = [];
		}
	}

	getAttiUtilizzati() {
		console.log('getAttiUtilizzati',this.gruppoModifica);
		this.viewCode = 'atto';
		if (this.gruppoModifica != 'select') {
			this.dataService.openLoader('CARICAMENTO GRUPPO TEMPLATES','caricamento lista templates in corso...');
			let body: any = {
				comuneId: this.dataService.getComuniService().getComuneId(),
				gruppoId: this.gruppoModifica
			};

			this.dataService.getCommon().getHttpClient().post<any>('/api/templates/get_utilizzati', JSON.stringify(body), { headers: this.headers })
				.subscribe(
					response => {
						console.log('atti utilizzati', response);
						this.attiUtilizzati = response.data;
						this.dataService.closeLoader();
					}
				);
		}
		else {
			this.daModificare = 'select';
			this.templateCode = '';
			this.attiUtilizzati = [];
		}
	}

	resetSelects() {
		console.log('RESET SELECTS');
		this.gruppoCrea = 'select';
		this.sourceGroup = 'gruppo';
		this.gruppoModifica = 'select';
		this.daAggiungere = 'select';
		this.daModificare = 'select';
		this.templateCode = '';
		this.attiDisponibili = [];
		this.attiUtilizzati = [];
		this.pdfStream = null;
		this.bollettino = false;
	}

	getAttoUtilizzatoById(idAtto) {
		let attoUtilizzato:any;
		for (let atto of this.attiUtilizzati) {
			if (atto.templates_atti_id == this.daModificare) {
				attoUtilizzato = atto;
				this.bollettino = Boolean(atto.bollettino);
			}
		}
		return attoUtilizzato;
	}

	getTemplateCode() {
		console.log('getTemplateCode',this.daModificare);
		if (this.daModificare != 'select') {
			this.dataService.openLoader('CARICAMENTO TEMPLATE','caricamento codice template in corso...');
			console.log('getTemplateCode',true);

			let atto = this.getAttoUtilizzatoById(this.daModificare);

			let template = 'atto.pug';
			this.editorMode = 'jade';

			if (this.viewCode == 'bollettino') {
				template = 'bollettino.pug';
			}
			else if (this.viewCode == 'stile') {
				template = 'atto.css';
				this.editorMode = 'css';
			}

			let path = 'templates/'+atto.codice_comune+'/'+atto.codice_gruppo+'/'+atto.codice_atto+'/'+template;

			let body = {
				path: path
			}

			this.dataService.getCommon().getHttpClient().post<any>('/api/templates/get_template_code', JSON.stringify(body), { headers: this.headers })
				.subscribe(
					response => {
						this.dataService.closeLoader();
						console.log('template code', response);
						if (response.success) {
							this.templateCode = response.data;
						}
						else {
							this.dataService.openMessage('ERRORE TEMPLATE',response.msg);
						}
					}
				);
		}
		else {
			console.log('getTemplateCode',false);
			this.templateCode = '';
		}
	}

	addTemplate(atto) {
		console.log('AGGIUNGI TEMPLATE');
		this.dataService.openLoader('INSERIMENTO TEMPLATE','aggiunta del nuovo template in corso...');

		let codiceComune = this.dataService.getComuniService().getComuneCodice();

		let codiceGruppo:string = '';
		for (let gruppo of this.gruppi) {
			if (gruppo.id == this.gruppoCrea) {
				codiceGruppo = gruppo.codice;
			}
		}

		let codiceAtto:string = '';
		for (let atto of this.attiDisponibili) {
			if (atto.id == this.daAggiungere) {
				codiceAtto = atto.codice;
			}
		}

		let source = 'templates/comune/'+this.sourceGroup+'/'+codiceAtto;

		if (this.sourceGroup != 'gruppo') {
			let sorgenteGruppo:string = '';
			for (let gruppo of this.gruppiSource) {
				if (gruppo.id == this.sourceGroup) {
					sorgenteGruppo = gruppo.codice;
				}
			}
			source = 'templates/'+codiceComune+'/'+sorgenteGruppo+'/'+codiceAtto;
		}

		let destination = 'templates/'+codiceComune+'/'+codiceGruppo+'/'+codiceAtto;

		let expressBody = {
			source: source,
			comune: codiceComune,
			gruppo: codiceGruppo,
			destination: destination
		}

		let mysqlBody = {
			templates_gruppi_id: this.gruppoCrea,
			templates_atti_id: this.daAggiungere
		}

		this.dataService.getCommon().getHttpClient().post<any>('/api/templates/crea', JSON.stringify(expressBody), { headers: this.headers })
			.subscribe(
				response => {
					if (response.success) {
						this.dataService.insert('templates', mysqlBody, true, (error,newId) => {
							this.dataService.closeLoader();
							if (error) {
								this.dataService.openMessage('ERRORE TEMPLATE','si è verificato un errore');
							}
							else {
								this.resetSelects();
							}
						});
					}
					else {
						console.log(response.msg);
						this.dataService.closeLoader();
						this.dataService.openMessage('ERRORE TEMPLATE', response.msg);
					}
				}
			);

		console.log('CODICI',codiceGruppo,codiceAtto);
	}

	simulaPratica() {
		console.log('SIMULA PRATICA', this.attoDaSimulare);
		if (this.attoDaSimulare.length) {
			this.dataService.openLoader('GENERAZIONE ANTEPRIMA','');

			let atto = this.getAttoUtilizzatoById(this.daModificare);

			let file = 'atto.pug';

			if (this.viewCode == 'bollettino') {
				file = 'bollettino.pug';
			}
			else if (this.viewCode == 'stile') {
				file = 'atto.css';
			}

			let filename = './templates/'+atto.codice_comune+'/'+atto.codice_gruppo+'/'+atto.codice_atto+'/'+file;

			let body = {
				source: this.templateCode,
				locals: this.dumpData,
				filename: filename,
				viewCode: this.viewCode,
				uid: this.attoDaSimulare,
				idComune: this.dataService.getComuniService().getComuneId(),
				doc_id: this.daModificare,
				doc_prex: atto.codice_atto
			}

			console.log('BODY SIMULA PRATICA', body);
			this.dataService.getCommon().getHttpClient().post<any>('/api/pratiche/simula', JSON.stringify(body), { headers: this.headersPDF })
			.subscribe(
				response => {
					if(response instanceof Blob){
						console.log('preview', response, window.URL.createObjectURL(response));
						this.pdfStream = this.domSanitizer.bypassSecurityTrustResourceUrl( window.URL.createObjectURL(response) );
					}else{
						console.log("errore", response);
					}
					this.dataService.closeLoader();
				}
			);
		}
	}

	annullaModifiche() {
		this.getTemplateCode();
	}

	salvaTemplate() {
		this.dataService.openLoader('SALVATAGGIO TEMPLATE','');

		let atto = this.getAttoUtilizzatoById(this.daModificare);

		let file = 'atto.pug';

		if (this.viewCode == 'bollettino') {
			file = 'bollettino.pug';
		}
		else if (this.viewCode == 'stile') {
			file = 'atto.css';
		}

		let destination = './templates/'+atto.codice_comune+'/'+atto.codice_gruppo+'/'+atto.codice_atto+'/'+file;

		let body = {
			codice: this.templateCode,
			destination: destination
		}

		this.dataService.getCommon().getHttpClient().post<any>('/api/templates/modifica', JSON.stringify(body),	{ headers: this.headers })
			.subscribe(
				response => {
					console.log(response);
					this.dataService.closeLoader();
					this.dataService.openMessage(response.msg,'');
				}
			);
	}

	defaultTemplate() {
		this.dataService.openLoader('SALVATAGGIO TEMPLATE','');

		let atto = this.getAttoUtilizzatoById(this.daModificare);
		let codice = atto.codice_atto;
		let file = 'atto.pug';

		if (this.viewCode == 'bollettino') {
			file = 'bollettino.pug';
		}
		else if (this.viewCode == 'stile') {
			file = 'atto.css';
		}

		let body = {
			templateCode: this.templateCode,
			codice: codice,
			file: file
		}

		this.dataService.getCommon().getHttpClient().post<any>('/api/templates/set_default', JSON.stringify(body), { headers: this.headers })
			.subscribe(
				response => {
					console.log(response);
					this.dataService.closeLoader();
					this.dataService.openMessage(response.msg,'');
				}
			);
	}

	ngOnDestroy() {
		this.comuneSync.unsubscribe();
		this.gruppiSync.unsubscribe();
		this.praticheSync.unsubscribe();
	}
}
